import type { ConditionModel, ConditionStatuses } from '@ctw/shared/api/fhir/models/condition';
import type { ViewOption } from '@ctw/shared/content/resource/view-button';

// Filter for clinicalStatus and/or verificationStatus
function statusFilter(statuses: Array<ConditionStatuses>) {
  return (data: Array<ConditionModel>) => data.filter((c) => statuses.includes(c.displayStatus));
}

export type ConditionViewOptions = 'Current' | 'Past' | 'All';

const viewOptions: Array<ViewOption<ConditionModel>> = [
  {
    display: 'Current',
    filters: [statusFilter(['Active', 'Pending', 'Unknown'])],
  },
  {
    display: 'Past',
    filters: [statusFilter(['Inactive', 'Refuted'])],
  },
  {
    display: 'All',
    filters: [(data: Array<ConditionModel>) => data],
  },
];

export const statusView = {
  viewOptions,
  current: viewOptions[0],
  past: viewOptions[1],
  all: viewOptions[2],
};
